var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('query-filter',{staticClass:"mt-6 mb-2",attrs:{"fields":_vm.fields},scopedSlots:_vm._u([{key:"dateRange",fn:function(ref){
var value = ref.value;
var listeners = ref.listeners;
return [_c('date-range-picker',{attrs:{"value":_vm.dateValue,"label":_vm.$t('Date')},on:{"input":function (v) { return listeners.input(v); }}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }